.stack {
    display: contents;
}
